import { useNavigate, } from "react-router-dom";

import { RoutesMap, } from "../../../routes.tsx";
import { ProfilePageView, } from "./ProfilePageView.tsx";
import { MODERATOR_LOCALSTORAGE_KEYS, useModeratorStore, } from "../../../store/moderatorStore.ts";

export function ProfilePageModerator() {
  const navigate = useNavigate();
  const reset = useModeratorStore(state => state.reset,);
  const profile = useModeratorStore(state => state.profile,);

  const handleLogout = () => {
    localStorage.removeItem(MODERATOR_LOCALSTORAGE_KEYS.phone,);
    localStorage.removeItem(MODERATOR_LOCALSTORAGE_KEYS.code,);

    navigate(RoutesMap.login.index,);

    setTimeout(() => {
      reset();
    }, 0,);
  };

  return (
    <ProfilePageView
      isFetching={false}
      userData={{
        phone: profile?.phone,
        email: profile?.email,
        fullName: profile?.fullName ?? "",
        birthdate: profile?.birthdate ?? "",
        nationality: profile?.nationality ?? "",
        passportSeries: profile?.passportSeries,
        passportNumber: profile?.passportNumber,
        passportIssueDate: profile?.passportIssueDate ?? "",
        passportDivisionCode: profile?.passportDivisionCode ?? "",
        registrationAddressString: profile?.registrationAddressString ?? "",
        moderatorQR: profile?.qr ?? "",
      }}
      documents={{
        isFetching: false,
        isSuccess: false,
        isError: false,
        data: undefined,
      }}
      handleLogout={handleLogout}
    />
  );
}
